// extracted by mini-css-extract-plugin
export default {"wrapper":"SeriesList_wrapper__xzINp"};